import React, { useCallback } from "react";
import {
    FETCH_DATA_START,
    FETCH_MAIN_DATA,
    FETCH_LIST_DATA,
    FETCH_DATA_FAILURE,
    UUI_GLOBAL,
    UUI_THEME,
    SHOW_MESS_APP
} from '../types'
import { shallowEqual, useDispatch,useSelector } from 'react-redux'

export const UiGlobalcss = (glcss) => {
  return (dispatch, getState) => {
    return dispatch({ type: UUI_GLOBAL, payload: {globalCss: glcss} })
  }
}
export const UiThemecss = (glcss) => {
  return (dispatch, getState) => {
    return dispatch({ type: UUI_THEME, payload: {themeCss: glcss} })
  }
}
export const UiConfigApp = (blocks) => {
  return (dispatch, getState) => {
    return dispatch({ type: UUI_GLOBAL, payload: blocks })
  }
}
export const ShowMessageApp = (curmess) => {
  return (dispatch, getState) => {
    //console.log('obj----AddRememberApp-----',obj)
    if (!(curmess.draw)) {
      curmess.draw = { vertical: 'top', horizontal: 'left' }
    }
    return dispatch({ type: SHOW_MESS_APP, payload: curmess })
  }
}
 
/*export const fetchData = (filters) => {
    //console.log('filters__',filters)
    return async dispatch => {
      dispatch( CreateAct(FETCH_DATA_START))
      await fetchDataApi(filters)
        .then((maindata) => {
          //console.log('maindata__',maindata)
          dispatch(CreateAct(FETCH_MAIN_DATA,{maindata})) 
        })
        .catch((error) => {
          dispatch({
            type: FETCH_DATA_FAILURE,
            payload: error,
            error: true
          })
           console.log(error)
           })
    }
  }*/